export function getScrollbarWidth(): number {
  const el = document.createElement('div')
  el.style.cssText = 'overflow:scroll;visibility:hidden;position:absolute'
  document.body.appendChild(el)
  const width = el.offsetWidth - el.clientWidth
  document.body.removeChild(el)
  return width
}
